<h1 mat-dialog-title>Confirm</h1>
<div mat-dialog-content>
    <p>Are you sure you want to delete this?</p>
    <mat-checkbox (change)="setAll($event.checked)" style="margin-right: 30px;">
        Delete Permanently
    </mat-checkbox>
</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-accent mr-16" (click)="onConfirm()">Confirm</button>
    <button mat-button (click)="dialogRef.close(false)">Cancel</button>
</div>